module.exports = __webpack_public_path__ + "static/media/register_success.8ef164b8.svg";